import { ROUTES } from '@router'

export function getTitleTranslationKey({
  route = {},
  breadcrumb = [],
  translations = {},
} = {}) {
  switch (route.name) {
    case ROUTES.REVIEWS.PAGES.PRODUCT: {
      const product = route.query?.productName

      return product
        ? {
            key: translations.titleProduct,
            params: { product },
          }
        : { key: translations.titlePlaceholder }
    }

    case ROUTES.REVIEWS.PAGES.MERCHANT: {
      const merchant = breadcrumb[1]?.title

      return merchant
        ? { key: translations.titleMerchantProducts, params: { merchant } }
        : { key: translations.titlePlaceholder }
    }
    case ROUTES.REVIEWS.PAGES.LANDING: {
      const listing = breadcrumb[1]?.title

      return listing
        ? { key: translations.titleListingProduct, params: { listing } }
        : { key: translations.titlePlaceholder }
    }
    case ROUTES.REVIEWS.PAGES.ALL:
    default:
      return { key: translations.titleAllProducts }
  }
}
